const CHATWOOT_TOKEN = process.env.EXPO_PUBLIC_CHATWOOT_WEBSITE_TOKEN ?? "";
const BASE_URL =
  process.env.EXPO_PUBLIC_CHATWOOT_BASE_URL ?? "https://app.chatwoot.com";

declare global {
  interface Window {
    chatwootSettings: object;
    chatwootSDK: { run: (config: object) => void };
    $chatwoot?: {
      toggle?: (state?: "open" | "close") => void;
      setUser?: (identifier: string, user: object) => void;
      setCustomAttributes?: (attributes: object) => void;
      reset?: () => void;
    };
    _chatwootReady: boolean;
    _chatwootInitialized: boolean;
  }
}

export { BASE_URL, CHATWOOT_TOKEN };

export function ensureChatwootLoaded(
  onReady: () => void,
  onError?: (message: string) => void,
) {
  if (window._chatwootReady) {
    onReady();
    return;
  }

  const readyHandler = () => {
    window._chatwootReady = true;
    onReady();
  };

  window.addEventListener("chatwoot:ready", readyHandler, { once: true });

  if (document.getElementById("chatwoot-sdk")) {
    return;
  }

  window.chatwootSettings = {
    hideMessageBubble: true,
    position: "right",
    locale: "en",
    type: "standard",
    showPopoutButton: false,
  };

  const script = document.createElement("script");
  script.id = "chatwoot-sdk";
  script.src = `${BASE_URL}/packs/js/sdk.js`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    if (window._chatwootInitialized) {
      return;
    }

    window.chatwootSDK.run({
      websiteToken: CHATWOOT_TOKEN,
      baseUrl: BASE_URL,
    });
    window._chatwootInitialized = true;
  };
  script.onerror = () => {
    window.removeEventListener("chatwoot:ready", readyHandler);
    onError?.("Chat support failed to load.");
  };
  document.head.appendChild(script);
}
